
(function(){
var MAAT = {
  borduren: { P: 'Klein', K: 'Klein', M: 'Medium', G: 'Groot' },
  dtf: { P: 'Klein', K: 'Klein', M: 'Medium', G: 'Groot' }
};
var MAAT_LABEL = { P: 'klein logo', K: 'klein logo', M: 'medium logo', G: 'groot logo' };
function initT2Y(root){
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var cfg = JSON.parse(root.querySelector('[data-t2y-config]').textContent);
  var formId = root.dataset.form;
  var RATE = (window.T2Y_BTW && window.T2Y_BTW.rate) || 1.21;
  var euro = function(c){ return '€ ' + (c/100).toFixed(2).replace('.', ','); };
  var gridEl = root.querySelector('[data-grid]');
  var cache = {};

  // toeslagen: "techniek|formaat" -> [{min, id, price}] oplopend
  var feeTab = {};
  Object.keys(cfg.fee || {}).forEach(function(k){
    var p = k.split('|'); var min = parseInt(String(p[2] || '').replace(/\D/g, ''), 10) || 1;
    var key = p[0] + '|' + p[1];
    (feeTab[key] = feeTab[key] || []).push({ min: min, id: cfg.fee[k].id, price: cfg.fee[k].price });
  });
  Object.keys(feeTab).forEach(function(k){ feeTab[k].sort(function(a, b){ return a.min - b.min; }); });
  function feeFor(tech, formaat, n){
    var rows = feeTab[tech + '|' + formaat]; if (!rows) return null;
    var best = null; rows.forEach(function(r){ if (n >= r.min) best = r; });
    return best || rows[0];
  }

  function form(){ return document.getElementById(formId); }
  function techniek(){ var r = root.querySelector('input[name="properties[Bedrukking]"]:checked'); return r ? r.value : 'Onbedrukt'; }
  function posities(){ return Array.prototype.slice.call(root.querySelectorAll('[data-positie]:checked')).slice(0, cfg.maxPosities || 4).map(function(i){ return { naam: i.value, maat: i.dataset.maat || 'K' }; }); }
  function kleuren(){ var r = root.querySelector('[data-kleur]:checked'); return r ? parseInt(r.value, 10) : 1; }
  function qtyInput(){ var f = form(); return f && f.querySelector('[name="quantity"]'); }
  function variantId(){ var f = form(); var i = f && f.querySelector('[name="id"]'); return i ? String(i.value) : null; }
  function currentVariant(){ var id = variantId(); return id ? cfg.variants[id] || cache['id:' + id] || null : null; }

  // ---------- maatraster ----------
  // ---------- aantal bovenaan (producten zonder maatraster, bv. onesize) ----------
  var stepEl = null;
  function buildStepper(){
    if (gridEl || stepEl || !qtyInput()) return;
    if (!document.getElementById('t2y-step-css')) {
      var st = document.createElement('style'); st.id = 't2y-step-css';
      st.textContent = '.t2y-step{display:inline-flex;align-self:flex-start;width:max-content;max-width:100%;align-items:center;border:1px solid rgba(0,0,0,.15);border-radius:999px;overflow:hidden}.t2y-step button{width:46px;height:46px;border:0;background:transparent;font-size:22px;line-height:1;cursor:pointer;color:inherit}.t2y-step button:hover{background:rgba(0,0,0,.05)}.t2y-step input{width:64px;border:0;text-align:center;font-size:17px;font-weight:600;background:transparent;-moz-appearance:textfield}.t2y-step input::-webkit-outer-spin-button,.t2y-step input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}';
      document.head.appendChild(st);
    }
    stepEl = document.createElement('div');
    stepEl.className = 't2y-perso__group'; stepEl.setAttribute('data-aantal', '');
    stepEl.innerHTML = '<div class="t2y-perso__label h6">Hoeveel stuks?</div><div class="t2y-step"><button type="button" data-step="-1" aria-label="Minder">−</button><input type="number" min="1" step="1" inputmode="numeric" aria-label="Aantal stuks"><button type="button" data-step="1" aria-label="Meer">+</button></div>';
    root.insertBefore(stepEl, root.firstChild);
    var inp = stepEl.querySelector('input');
    var q0 = qtyInput(); inp.value = (q0 && parseInt(q0.value, 10)) || 1;
    function push(v){
      v = Math.max(1, parseInt(v, 10) || 1); inp.value = v;
      var q = qtyInput(); if (q) { q.value = v; q.dispatchEvent(new Event('input', { bubbles: true })); q.dispatchEvent(new Event('change', { bubbles: true })); }
      update();
    }
    stepEl.addEventListener('click', function(e){ var b = e.target.closest('[data-step]'); if (!b) return; e.preventDefault(); push((parseInt(inp.value, 10) || 1) + parseInt(b.dataset.step, 10)); });
    inp.addEventListener('change', function(){ push(inp.value); });
    inp.addEventListener('input', function(){ if (inp.value !== '') push(inp.value); });
    inp.addEventListener('focus', function(){ inp.select(); });
  }
  function hideThemeSizeAndQty(){
    buildStepper();
    if (stepEl) { var qs = qtyInput(); if (qs) { var ws = qs.closest('.product-form-buttons > *') || qs.closest('quantity-selector-component, quantity-selector, .quantity-selector, .quantity') || qs.parentElement; ws && !ws.classList.contains('t2y-hide') && ws.classList.add('t2y-hide'); } }
    if (!gridEl) {
      // onesize: een maatkeuze met maar één optie heeft geen zin
      var sec0 = root.closest('.shopify-section') || document;
      sec0.querySelectorAll('.variant-option, fieldset').forEach(function(fs){
        var lg = fs.querySelector('.variant-option__label, legend');
        if (lg && /^\s*(maat|size)\b/i.test(lg.textContent) && fs.querySelectorAll('input[type="radio"], option').length <= 1 && !fs.classList.contains('t2y-hide')) fs.classList.add('t2y-hide');
      });
      return;
    }
    var section = root.closest('.shopify-section') || document;
    section.querySelectorAll('.variant-option, fieldset').forEach(function(fs){
      var lg = fs.querySelector('.variant-option__label, legend');
      if (lg && /^\s*(maat|size)\b/i.test(lg.textContent) && !fs.classList.contains('t2y-hide')) fs.classList.add('t2y-hide');
    });
    var q = qtyInput(); if (q) { var w = q.closest('quantity-selector-component, quantity-selector, .quantity-selector, .quantity') || q.parentElement; w && !w.classList.contains('t2y-hide') && w.classList.add('t2y-hide'); }
  }
  function currentColor(){
    var v = currentVariant();
    if (v && v.options && cfg.colorIndex >= 0) return v.options[cfg.colorIndex];
    return null;
  }
  function findVariant(color, size){
    for (var id in cfg.variants) {
      var o = cfg.variants[id].options;
      if (o[cfg.sizeIndex] === size && (cfg.colorIndex < 0 || o[cfg.colorIndex] === color)) return { id: id, price: cfg.variants[id].price, available: cfg.variants[id].available };
    }
    var key = color + '|' + size;
    return cache[key] || null;
  }
  function fetchVariant(color, size){
    var key = color + '|' + size; if (cache[key] !== undefined) return Promise.resolve(cache[key]);
    var c = cfg.colorValues.filter(function(x){ return x.name === color; })[0];
    var s = cfg.sizeValues.filter(function(x){ return x.name === size; })[0];
    if (!s) return Promise.resolve(null);
    var ids = (c ? [c.id] : []).concat([s.id]).join(',');
    cache[key] = null;
    return fetch(cfg.url + '?option_values=' + ids + '&sections=variant-data').then(function(r){ return r.json(); }).then(function(j){
      var v = parseSection(j);
      if (v && v.options && v.options[cfg.sizeIndex] === size) { cache[key] = { id: String(v.id), price: v.price, available: v.available }; cache['id:' + v.id] = { price: v.price, available: v.available, options: v.options }; }
      return cache[key];
    }).catch(function(){ return null; });
  }
  function parseSection(j){
    var raw = j && j['variant-data']; if (!raw) return null; if (typeof raw !== 'string') return raw;
    try { return JSON.parse(raw.slice(raw.indexOf('{'), raw.lastIndexOf('}') + 1)); } catch (e) { return null; }
  }
  function ensureCurrent(){
    var id = variantId(); if (!id || cfg.variants[id] || cache['id:' + id] !== undefined) return Promise.resolve();
    cache['id:' + id] = null;
    return fetch(cfg.url + '?variant=' + id + '&sections=variant-data').then(function(r){ return r.json(); }).then(function(j){
      var v = parseSection(j);
      if (v) cache['id:' + id] = { price: v.price, available: v.available, options: v.options };
    }).catch(function(){});
  }
  function refreshGrid(){
    if (!gridEl) return Promise.resolve();
    return ensureCurrent().then(function(){
      var color = currentColor();
      var jobs = [];
      gridEl.querySelectorAll('.t2y-grid__cell').forEach(function(cell){
        var size = cell.dataset.size; var v = findVariant(color, size);
        if (!v && !cfg.complete) jobs.push(fetchVariant(color, size));
      });
      return Promise.all(jobs).then(function(){
        gridEl.querySelectorAll('.t2y-grid__cell').forEach(function(cell){
          var v = findVariant(color, cell.dataset.size);
          cell.classList.toggle('is-out', !v);
          cell.querySelector('input').disabled = !v;
          cell.title = v ? '' : 'Niet beschikbaar in deze kleur';
        });
      });
    });
  }
  function gridLines(){
    if (!gridEl) return null;
    var color = currentColor(); var lines = [];
    gridEl.querySelectorAll('.t2y-grid__cell').forEach(function(cell){
      var n = parseInt(cell.querySelector('input').value, 10) || 0;
      cell.classList.toggle('is-filled', n > 0);
      if (n > 0) { var v = findVariant(color, cell.dataset.size); if (v) lines.push({ id: v.id, q: n, price: v.price, size: cell.dataset.size }); }
    });
    return lines;
  }

  // ---------- prijs ----------
  function totalQty(){
    var g = gridLines(); if (g) return g.reduce(function(s, l){ return s + l.q; }, 0);
    var q = qtyInput(); var n = q ? parseInt(q.value, 10) : 1; return isNaN(n) || n < 1 ? 1 : n;
  }
  // per positie de juiste toeslag (techniek + formaat + staffel op het aantal stuks)
  function feeLines(n){
    var t = techniek(); if (t === 'Onbedrukt') return [];
    var tk = t.toLowerCase(); var nn = Math.max(n, 1);
    return posities().map(function(p){
      var formaat = tk === 'zeefdruk' ? (kleuren() === 1 ? '1 kleur' : kleuren() + ' kleuren') : (MAAT[tk] || MAAT.dtf)[p.maat] || 'Klein';
      var f = feeFor(tk, formaat, nn);
      return f ? { id: f.id, price: f.price, pos: p, formaat: formaat } : null;
    }).filter(Boolean);
  }
  // borduren: eenmalig digitaliseren per positie, tenzij het logo al eens bij ons geborduurd werd
  function bordBestaand(){ var c = root.querySelector('[data-bord-bestaand]'); return !!(c && c.checked); }
  function bordVak(){
    var lg = root.querySelector('[data-logo]'); if (!lg || root.querySelector('[data-bord-vak]')) return;
    var f = feeFor('opstart borduren', 'Per logo', 1); if (!f) return;
    var d = document.createElement('div'); d.setAttribute('data-bord-vak', ''); d.hidden = true;
    d.innerHTML = '<p class="t2y-perso__hint">Borduren: eenmalige instel- en opstartkost van ' + euro(f.price) + ' (excl. btw) per positie. Zo maken we je logo klaar voor de borduurmachine.</p><label class="t2y-perso__hint" style="display:flex;gap:8px;align-items:center;cursor:pointer"><input type="checkbox" data-bord-bestaand name="properties[Logo al eens geborduurd]" value="Ja" form="' + formId + '" disabled> Dit logo lieten we al eens bij jullie borduren</label>';
    lg.appendChild(d);
  }
  // 28 okt (Wout): zelfde logo als een bestelling die al in de winkelmand zit: instel- en opstartkost maar één keer.
  // Bestelling = groep (_groep); logo-familie = _logo (eerste groep met dat logo). Posities die de familie al heeft, kosten niets meer.
  var winkelmand = null;
  function laadWinkelmand(){
    var rt = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(rt + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); }).then(function(c){ winkelmand = c; update(); }).catch(function(){});
  }
  function families(){
    var fam = {};
    if (!winkelmand || !winkelmand.items) return fam;
    winkelmand.items.forEach(function(i){
      var p = i.properties || {};
      if (i.product_type === 'Personalisatie' || !p._groep || !p.Bedrukking) return;
      var lg = p._logo || p._groep, f = fam[lg] = fam[lg] || { logo: lg, titel: i.product_title, tech: {} };
      var t = f.tech[p.Bedrukking] = f.tech[p.Bedrukking] || { pos: [], kleuren: p['Kleuren zeefdruk'] || '' };
      String(p['Positie bedrukking'] || '').split(', ').forEach(function(x){ if (x && t.pos.indexOf(x) < 0) t.pos.push(x); });
    });
    return fam;
  }
  function zelfdeKandidaat(){
    var t = techniek(); if (t !== 'Borduren' && t !== 'Zeefdruk') return null;
    var mijn = posities().map(function(p){ return p.naam; }), best = null, bestS = -1, fam = families();
    Object.keys(fam).forEach(function(k){
      var f = fam[k], ft = f.tech[t]; if (!ft) return;
      if (t === 'Zeefdruk' && String(ft.kleuren) !== String(kleuren())) return;
      var sc = mijn.filter(function(x){ return ft.pos.indexOf(x) >= 0; }).length;
      if (sc >= bestS) { bestS = sc; best = { logo: f.logo, titel: f.titel, pos: ft.pos }; }
    });
    return best;
  }
  function zelfdeVak(){
    var lg = root.querySelector('[data-logo]'); if (!lg || root.querySelector('[data-zelfde-vak]')) return;
    var d = document.createElement('div'); d.setAttribute('data-zelfde-vak', ''); d.hidden = true;
    d.innerHTML = '<label class="t2y-perso__hint" style="display:flex;gap:8px;align-items:flex-start;cursor:pointer"><input type="checkbox" data-zelfde checked form="' + formId + '" style="margin-top:3px"> <span data-zelfde-tekst></span></label>';
    lg.appendChild(d);
  }
  function zelfdeAan(){ var v = root.querySelector('[data-zelfde-vak]'), c = v && v.querySelector('[data-zelfde]'); return !!(v && !v.hidden && c && c.checked); }
  function nieuwePosities(){
    var pos = posities(); if (!zelfdeAan()) return pos;
    var k = zelfdeKandidaat(); if (!k) return pos;
    return pos.filter(function(p){ return k.pos.indexOf(p.naam) < 0; });
  }
  function setupInfo(n){
    var tb = techniek();
    if (tb === 'Borduren') {
      if (bordBestaand()) return null;
      var fb = feeFor('opstart borduren', 'Per logo', 1); if (!fb) return null;
      var pb = nieuwePosities().length; if (!pb) return null;
      return { id: fb.id, price: fb.price, q: pb, bord: true };
    }
    if (techniek() !== 'Zeefdruk') return null;
    var f = feeFor('opstart zeefdruk', 'Per kleur', 1); if (!f) return null;
    var pos = nieuwePosities().length; if (!pos) return null;
    var q = kleuren() * pos * (n >= 100 ? 2 : 1);
    return { id: f.id, price: f.price, q: q };
  }
  // naam per stuk: het logo-voorbeeld zet de namen als json in properties[_namen]
  function namenData(){
    var el = root.querySelector('input[data-t2y-namen]') || document.querySelector('input[data-t2y-namen]');
    if (!el || el.disabled || !el.value) return null;
    try { return JSON.parse(el.value); } catch (e) { return null; }
  }
  function namenInfo(){
    if (techniek() === 'Onbedrukt') return null;
    var d = namenData(); if (!d || !Object.keys(d).length) return null;
    var n = 0; Object.keys(d).forEach(function(k){ n += parseInt(d[k].aantal, 10) || 0; });
    var f = n ? (feeFor('tekst per stuk', 'Per tekst', n) || feeFor('namen per stuk', 'Per naam', n)) : null;
    return { data: d, n: n, id: f ? f.id : null, price: f ? f.price : 0 };
  }
  function staffelKorting(n){ var best = 0; cfg.staffels.forEach(function(s){ var p = s.split(':'); if (n >= parseInt(p[0],10) && parseFloat(p[1]) > best) best = parseFloat(p[1]); }); return best; }
  function volgendeStaffel(n){ var nxt = null; cfg.staffels.forEach(function(s){ var p = s.split(':'), min = parseInt(p[0],10); if (min > n && (!nxt || min < nxt.min)) nxt = {min:min, pct:parseFloat(p[1])}; }); return nxt; }
  function set(sel, txt){ var e = root.querySelector(sel); if (e && e.textContent !== txt) e.textContent = txt; }
  function isIncl(){ return !!(window.T2Y_BTW && window.T2Y_BTW.incl()); }
  function pair(name, c){ set('[data-p-' + name + ']', euro(isIncl() ? Math.round(c * RATE) : c)); }
  function btwLabels(){
    var inc = isIncl();
    var h = root.querySelector('.t2y-row--head span:nth-child(2)'); if (h && h.textContent !== (inc ? 'incl. btw' : 'excl. btw')) h.textContent = inc ? 'incl. btw' : 'excl. btw';
    var hints = root.querySelectorAll('[data-prijs] .t2y-perso__hint');
    var last = hints[hints.length - 1];
    if (last) { if (last.__orig == null) last.__orig = last.textContent; var nt = inc ? last.__orig.replace(/excl\. btw/i, 'incl. btw') : last.__orig; if (last.textContent !== nt) last.textContent = nt; }
  }

  function update(){
    var t = techniek();
    root.querySelector('[data-posities]').hidden = (t === 'Onbedrukt');
    root.querySelector('[data-logo]').hidden = (t === 'Onbedrukt');
    var kl = root.querySelector('[data-kleuren]'); if (kl) kl.hidden = (t !== 'Zeefdruk');
    zelfdeVak(); var zv = root.querySelector('[data-zelfde-vak]'), kand = (t === 'Borduren' || t === 'Zeefdruk') ? zelfdeKandidaat() : null;
    if (zv) { zv.hidden = !kand; if (kand) set('[data-zelfde-tekst]', 'Zelfde logo als bij ' + kand.titel + ' in je winkelmand: de instel- en opstartkost betaal je maar één keer.'); }
    bordVak(); var bv = root.querySelector('[data-bord-vak]'); if (bv) { bv.hidden = (t !== 'Borduren'); var bc = bv.querySelector('input'); if (bc) bc.disabled = (t !== 'Borduren'); }
    var kv = root.querySelector('[data-kleuren-veld]'); if (kv) kv.value = t === 'Zeefdruk' ? String(kleuren()) : '';
    var pos = posities();
    root.querySelector('[data-positie-veld]').value = t === 'Onbedrukt' ? '' : pos.map(function(p){ return p.naam; }).join(', ');
    var lines = gridLines();
    var n = totalQty();
    var cv = currentVariant();
    var textielTotaal, basisStuk;
    if (lines && lines.length) { textielTotaal = lines.reduce(function(s, l){ return s + l.price * l.q; }, 0); basisStuk = Math.round(textielTotaal / n); }
    else { basisStuk = cv ? cv.price : null; textielTotaal = basisStuk == null ? null : basisStuk * n; }
    if (gridEl) set('[data-grid-info]', n ? n + ' stuk' + (n === 1 ? '' : 's') + ' gekozen' : 'Vul bij minstens één maat een aantal in.');
    var box = root.querySelector('[data-prijs]');
    if (basisStuk == null) { box.hidden = true; return; }
    var fl = feeLines(n);
    var feeStuk = fl.reduce(function(s, f){ return s + f.price; }, 0);
    var su = setupInfo(n); var suTotaal = su ? su.price * su.q : 0;
    var pct = staffelKorting(n);
    var textielNa = Math.round(textielTotaal * (1 - pct/100));
    var nm = namenInfo(); var nmTotaal = nm && nm.id ? nm.price * nm.n : 0;
    var totaal = textielNa + feeStuk * n + suTotaal + nmTotaal;
    box.hidden = false;
    btwLabels();
    pair('textiel', Math.round(basisStuk * (1 - pct/100)));
    // één rij per positie, zodat de klant ziet wat elke positie kost
    var feeRow = root.querySelector('[data-row-fee]');
    feeRow.hidden = true;
    var sig = t + '|' + fl.map(function(f){ return f.pos.naam + ':' + f.formaat + ':' + f.price; }).join(',') + '|' + isIncl();
    if (feeRow.__sig !== sig) {
      feeRow.__sig = sig;
      root.querySelectorAll('.t2y-row--pos').forEach(function(r){ r.remove(); });
      var anchor = feeRow;
      fl.forEach(function(f){
        var r = document.createElement('div'); r.className = 't2y-row t2y-row--pos';
        var lbl = t === 'Zeefdruk' ? t + ' ' + f.pos.naam.toLowerCase() + ' (' + f.formaat + ')' : t + ' ' + f.pos.naam.toLowerCase() + ' (' + MAAT_LABEL[f.pos.maat] + ')';
        var a = document.createElement('span'); a.textContent = lbl;
        var b = document.createElement('span'); b.textContent = euro(isIncl() ? Math.round(f.price * RATE) : f.price);
        r.appendChild(a); r.appendChild(b); r.appendChild(document.createElement('span'));
        anchor.parentNode.insertBefore(r, anchor.nextSibling); anchor = r;
      });
    }
    var sr = root.querySelector('[data-row-setup]');
    if (sr) { sr.hidden = !su; if (su && su.bord) { set('[data-p-setup-label]', 'Instel- en opstartkost, eenmalig (' + su.q + (su.q === 1 ? ' positie' : ' posities') + ' x ' + euro(isIncl() ? Math.round(su.price * RATE) : su.price) + ')'); pair('setup', suTotaal); } else if (su) { set('[data-p-setup-label]', 'Instel- en opstartkost, eenmalig (' + kleuren() + (kleuren() === 1 ? ' kleur' : ' kleuren') + ' x ' + nieuwePosities().length + (nieuwePosities().length === 1 ? ' positie' : ' posities') + (n >= 100 ? ' x 2' : '') + ')'); pair('setup', suTotaal); } }
    var nr = root.querySelector('[data-row-namen]');
    if (!nr) {
      var tr = root.querySelector('.t2y-row--totaal');
      if (tr) { nr = document.createElement('div'); nr.className = 't2y-row'; nr.setAttribute('data-row-namen', ''); nr.innerHTML = '<span data-p-namen-label></span><span data-p-namen></span><span data-p-namen-i></span>'; tr.parentNode.insertBefore(nr, tr); }
    }
    if (nr) { nr.hidden = !nmTotaal; if (nmTotaal) { set('[data-p-namen-label]', 'Tekst per stuk (' + nm.n + (nm.n === 1 ? ' stuk' : ' stuks') + ' x ' + euro(isIncl() ? Math.round(nm.price * RATE) : nm.price) + ')'); pair('namen', nmTotaal); } }
    // 28 okt (Wout): per stuk = alles inbegrepen, ook de eenmalige opstart (zeefdruk/digitaliseren) en de tekst per stuk, verdeeld over het aantal stuks
    var stukNu = n > 0 ? Math.round(totaal / n) : Math.round(basisStuk * (1 - pct/100)) + feeStuk;
    pair('stuk', stukNu);
    if (n === 0) { set('[data-p-totaal-label]', 'Totaal: vul eerst je aantallen in'); set('[data-p-totaal]', '–'); }
    else { set('[data-p-totaal-label]', 'Totaal voor ' + n + ' stuk' + (n === 1 ? '' : 's') + (pct ? ' (-' + pct + '% op het artikel)' : '')); pair('totaal', totaal); }
    var nx = volgendeStaffel(n);
    var msg = '';
    if (nx) {
      var fl2 = feeLines(nx.min);
      var su2 = setupInfo(nx.min);
      var stuk2 = Math.round(basisStuk * (1 - nx.pct/100)) + fl2.reduce(function(s, f){ return s + f.price; }, 0) + Math.round(((su2 ? su2.price * su2.q : 0) + nmTotaal) / nx.min);
      var fmtP = function(c){ return euro(isIncl() ? Math.round(c * RATE) : c); };
      msg = stuk2 < stukNu ? 'Vanaf ' + nx.min + ' stuks betaal je ' + fmtP(stuk2) + ' per stuk in plaats van ' + fmtP(stukNu) + '.' : 'Vanaf ' + nx.min + ' stuks krijg je ' + nx.pct + '% korting op het artikel.';
    } else if (pct) { msg = 'Je krijgt de hoogste staffelkorting.'; }
    if (t !== 'Onbedrukt' && pos.length === 0) msg = 'Kies minstens één positie voor je logo.';
    set('[data-p-staffel]', msg);
  }

  root.addEventListener('input', update);
  var info = root.querySelector('.t2y-info');
  if (info) {
    info.querySelector('.t2y-info__btn').addEventListener('click', function(e){ e.preventDefault(); var o = info.classList.toggle('is-open'); this.setAttribute('aria-expanded', String(o)); });
    document.addEventListener('click', function(e){ if (!info.contains(e.target)) { info.classList.remove('is-open'); } });
  }
  var up = root.querySelector('.t2y-upload input');
  if (up) up.addEventListener('change', function(){ var n = this.files && this.files[0] ? this.files[0].name : ''; root.querySelector('[data-upload-name]').textContent = n || 'Nog geen bestand'; this.closest('.t2y-upload').classList.toggle('has-file', !!n); });
  var lastMode = null; document.addEventListener('t2y:btw', function(){ var m = isIncl(); if (m !== lastMode) { lastMode = m; update(); } });
  document.addEventListener('t2y:namen', function(){ update(); });
  root.addEventListener('change', update);
  if (gridEl) gridEl.addEventListener('focusin', function(e){ if (e.target.tagName === 'INPUT') e.target.select(); });
  document.addEventListener('change', function(e){ var f = form(); if (f && (f.contains(e.target) || e.target.getAttribute('form') === formId)) setTimeout(update, 30); });
  document.addEventListener('input', function(e){ if (e.target && e.target.name === 'quantity') setTimeout(update, 30); });
  document.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('quantity-selector-component, quantity-selector, .quantity')) setTimeout(update, 60); });
  var lastVid = null;
  setInterval(function(){ hideThemeSizeAndQty(); var v = variantId(); if (v !== lastVid) { lastVid = v; refreshGrid().then(update); } }, 250);
  function boot(){ hideThemeSizeAndQty(); refreshGrid().then(update).then(laadWinkelmand); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // ---------- winkelmand: maten + toeslagen in één aanvraag ----------
  window.__t2yBuild = function(fd){
    var lines = gridLines();
    if (!lines) lines = [{ id: fd.get('id'), q: parseInt(fd.get('quantity'), 10) || 1 }];
    var total = lines.reduce(function(s, l){ return s + l.q; }, 0);
    var fl = feeLines(total); var su = setupInfo(total); var nm = namenInfo();
    if (!gridEl && !fl.length && !nm) return null; // niets speciaals, laat het thema doen
    var nf = new FormData(), i = 0, props = [];
    var groep = (fl.length || su || nm) ? 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6) : null;
    fd.forEach(function(v, k){ if (k.indexOf('properties[') === 0 && k !== 'properties[_namen]') props.push([k, v]); });
    if (!lines.length) { nf.append('items[0][id]', fd.get('id')); nf.append('items[0][quantity]', '0'); }
    lines.forEach(function(l){
      nf.append('items[' + i + '][id]', l.id); nf.append('items[' + i + '][quantity]', String(l.q));
      props.forEach(function(p){
        if (p[1] === '') return;
        if (p[1] instanceof File) { if (i !== 0 || !p[1].size) return; }
        nf.append(p[0].replace('properties[', 'items[' + i + '][properties]['), p[1]);
      });
      if (nm) Object.keys(nm.data).forEach(function(pos){
        var d = nm.data[pos] || {}, m = d.maten || {};
        var lijst = l.size != null ? (m[l.size] || []) : Object.keys(m).reduce(function(a, k){ return a.concat(m[k]); }, []);
        var v;
        if (!d.aantal) v = 'nog door te geven';
        else if (!lijst.length) v = 'geen tekst (' + l.q + ' stuk' + (l.q === 1 ? '' : 's') + ')';
        else v = lijst.join(', ') + (lijst.length < l.q ? ' + ' + (l.q - lijst.length) + ' zonder tekst' : '') + (d.stijl ? ' (' + d.stijl + ')' : '');
        nf.append('items[' + i + '][properties][Tekst per stuk ' + pos + ']', v);
      });
      if (groep) {
        nf.append('items[' + i + '][properties][_groep]', groep);
        var kz = zelfdeAan() ? zelfdeKandidaat() : null;
        nf.append('items[' + i + '][properties][_logo]', kz ? kz.logo : groep);
        if (kz) nf.append('items[' + i + '][properties][Zelfde logo als]', kz.titel);
      }
      i++;
    });
    if (total > 0) {
      fl.forEach(function(f){
        nf.append('items[' + i + '][id]', f.id); nf.append('items[' + i + '][quantity]', String(total));
        nf.append('items[' + i + '][properties][Voor]', cfg.titel);
        nf.append('items[' + i + '][properties][Positie]', f.pos.naam);
        nf.append('items[' + i + '][properties][_groep]', groep);
        i++;
      });
      if (nm && nm.id && nm.n > 0) {
        nf.append('items[' + i + '][id]', nm.id); nf.append('items[' + i + '][quantity]', String(nm.n));
        nf.append('items[' + i + '][properties][Voor]', cfg.titel);
        nf.append('items[' + i + '][properties][Positie]', Object.keys(nm.data).filter(function(k){ return nm.data[k].aantal; }).join(', '));
        nf.append('items[' + i + '][properties][_groep]', groep);
        i++;
      }
      if (su && su.q > 0) {
        nf.append('items[' + i + '][id]', su.id); nf.append('items[' + i + '][quantity]', String(su.q));
        nf.append('items[' + i + '][properties][Voor]', cfg.titel);
        nf.append('items[' + i + '][properties][_groep]', groep);
        if (su.bord) nf.append('items[' + i + '][properties][Uitleg]', 'Instel- en opstartkost borduren: ' + nieuwePosities().map(function(p){ return p.naam; }).join(', ') + ', eenmalig');
        else nf.append('items[' + i + '][properties][Uitleg]', kleuren() + (kleuren() === 1 ? ' kleur' : ' kleuren') + ' x ' + nieuwePosities().length + (nieuwePosities().length === 1 ? ' positie' : ' posities') + (total >= 100 ? ' x 2 (vanaf 100 stuks)' : '') + ', eenmalig');
        i++;
      }
    }
    if (fd.get('sections')) nf.append('sections', fd.get('sections'));
    return nf;
  };
  /* 28 okt (Wout): winkelmand als volledige pagina. Na "In winkelmand" op de productpagina meteen naar de winkelmand. */
  function naarWinkelmand(r){
    try {
      var ft = window.FoxTheme || {};
      if (!r || !r.ok || !ft.settings || ft.settings.cartType === 'drawer') return;
      var u = (ft.routes && ft.routes.cart_url) || '/cart';
      setTimeout(function(){ window.location.href = u; }, 250);
    } catch (e) {}
  }
  if (!window.__t2yFetchPatched) {
    window.__t2yFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function(input, init){
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add/.test(url) && init && init.body instanceof FormData) {
          var nf = window.__t2yBuild ? window.__t2yBuild(init.body) : null;
          var p = nf ? origFetch.call(window, input, Object.assign({}, init, { body: nf })) : origFetch.apply(window, arguments);
          return p.then(function(r){ naarWinkelmand(r); return r; });
        }
      } catch (e) { console.warn('[t2y]', e); }
      return origFetch.apply(window, arguments);
    };
  }
}
function scan(){ document.querySelectorAll('.t2y-perso').forEach(initT2Y); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
new MutationObserver(function(){ scan(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
